import { API_METHODS, API_URL, MAX_API_TIMEOUT } from "../constants/api.constants";
import { kf1AuthenticatedHttpClient} from "kfone-frontend-core";
import { AppEnvVariables } from "../constants/environment.constants";
export enum ReportStatus {
  SUBMITTED = "Submitted",
  COMPLETED = "Completed"
}

const getAllCountries = async (clientId?: any) => {
  const configUrl = clientId
    ? `${AppEnvVariables.API_DOMAIN}${API_URL.COUNTRY}?clientId=${clientId}`
    : `${AppEnvVariables.API_DOMAIN}${API_URL.COUNTRY}`;
  const config: any = {
    method: API_METHODS.GET,
    url: configUrl,
    timeout: MAX_API_TIMEOUT,
  };
  const res = await kf1AuthenticatedHttpClient(config);
  return res;
};
const getCountryDetails = async (CountryCode: string) => {
  const configUrl = `${AppEnvVariables.API_DOMAIN}${API_URL.MARKETS}?countryCode=${CountryCode}`;
  const config: any = {
    method: API_METHODS.GET,
    url: configUrl
  };
  const res = await kf1AuthenticatedHttpClient(config);
  return res.data;
};

export { getAllCountries, getCountryDetails };
